import { useEffect, useState } from 'react';

export const usePersistValue = (storeState) => {
  const [valueToBePersisted, setValueToBePersisted] = useState(storeState);

  useEffect(() => {
    if (valueToBePersisted !== null) {
      return setValueToBePersisted((previousValue) => previousValue);
    }
    return setValueToBePersisted(storeState);
  }, [storeState]);

  return valueToBePersisted;
};
